import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles'
import { darken, lighten } from 'polished'

const brandColors = {
	primary: {
		main: '#003B5C',
		light: lighten(0.02, '#003B5C'),
		// "rgb(0, 41, 64)"
		// "rgb(51, 98, 124)"
		// #005564
		// 'rgba(0, 0, 0, 0.54)'
	},
	secondary: {
		main: '#FFA06A',
	},
	tertiary: {
		dark: darken(0.1, '#00788D'),
		main: '#00788D',
		light: lighten(0.09, '#00788D'),
	},
}

/**
 * color configuration: https://material-ui.com/customization/palette/
 * palette default: https://material-ui.com/customization/default-theme/
 * dark, light and contrastText are calulated based on main
 */
export const muiTheme = createMuiTheme({
	breakpoints: {
		values: {
			xs: 380,
			sm: 569,
			md: 768,
			lg: 992,
			xl: 1200,
			max: 1366,
		},
	},
	palette: {
		...brandColors,
		action: {
			focus: '#0d8ed1',
		},
		badges: {
			article: '#00348D',
			category: brandColors.tertiary.main,
			editorsPick: brandColors.tertiary.main,
			question: '#008D64',
		},
		error: {
			main: '#ff4136',
		},
		grey: {
			50: '#F2F5F7',
			100: '#FAFAFA',
			200: '#EEEEEE',
			300: '#D7D7D7',
			400: '#B0B0B0',
			500: '#7A7A7A',
			600: '#505050',
			700: '#2D2D2D',
			800: '#181818',
			900: '#000000',
		},
		old: {
			green: '#A1D884',
		},
		text: {
			primary: '#49485B',
		},
		contrastThreshold: 3,
		tonalOffset: 0.2,
	},
	typography: {
		fontFamily: 'Poppins, sans-serif',
		button: {
			fontFamily: 'Montserrat ExtraBold',
			fontSize: '.8rem',
			letterSpacing: '2.4px',
		},
		h1: {
			fontFamily: 'Poppins Bold, sans-serif',
			fontSize: '3.25rem',
			marginBottom: '1rem',
		},
		h2: {
			fontFamily: 'Poppins SemiBold, sans-serif',
			fontSize: '2.625rem',
		},
		subtitle1: {
			fontFamily: 'Montserrat SemiBold',
		},
		subtitle2: {
			fontFamily: 'Montserrat Medium',
		},
	},
})

const { palette } = muiTheme
export const bdcMuiTheme = createMuiTheme({
	...responsiveFontSizes(muiTheme),
	palette: {
		...palette,
		link: {
			author: {
				hover: palette.tertiary.main,
			},
			breadcrumb: {
				hover: palette.tertiary.main, // same as authorbio??
			},
			content: {
				main: '#087EE2', // replace??
			},
		},
	},
	overrides: {
		MuiButton: {
			root: {
				background: palette.secondary.main,
				borderRadius: 0,
				color: '#044A58',
				transition: 'all 0.4s ease',
				'&:hover': {
					backgroundColor: palette.tertiary.main,
					color: palette.common.white,
				},
			},
			text: {
				padding: '15px 8px',
			},
		},
	},
})
